// 若依上传返回的 /profile/... 是后端静态资源路径，开发态需使用接口服务的 origin。
export function mediaUrl(value) {
  const path = String(value || '').split(',')[0].trim()
  if (!path) return ''
  if (/^https?:\/\//i.test(path)) return path
  if (!path.startsWith('/profile/')) return ''
  const base = process.env.VUE_APP_BASE_API || ''
  try { return /^https?:\/\//i.test(base) ? new URL(path, base).href : path } catch (e) { return path }
}
